/* @flow */

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetIntroWebcastBanner as GetIntroWebcastBannerQuery,
    GetIntroWebcastBanner_introWebcastBanner as IntroWebcastBanner,
} from 'nutshell-graphql-types';

import GET_INTRO_WEBCAST_BANNER from '../queries/get-intro-webcast-banner.graphql';

export const useGetIntroWebcastBanner = (): {
    introWebcastBanner: IntroWebcastBanner | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetIntroWebcastBannerQuery, Record<any, any>>(
        GET_INTRO_WEBCAST_BANNER
    );

    return {
        introWebcastBanner: data?.introWebcastBanner ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
